import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "mobile-bar bg--pink" }
const _hoisted_2 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MainIcon = _resolveComponent("MainIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.links, (link, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        class: "mobile-bar-icon display--flex align--center justify--center",
        onClick: ($event: any) => (_ctx.iconAction(link))
      }, [
        _createVNode(_component_MainIcon, {
          size: "1.9em",
          background: false,
          icon: link.icon,
          color: "#222"
        }, null, 8, ["icon"])
      ], 8, _hoisted_2))
    }), 128))
  ]))
}